import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9543460c"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-external"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "column-headers-container",
        style: _normalizeStyle(_ctx.gridTemplateColumns)
    }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enabledColumns, (column) => {
            return (_openBlock(), _createElementBlock("div", {
                key: column.id,
                class: _normalizeClass(['column-header', { 'custom-column-header': column.isCustom }])
            }, [
                _createElementVNode("div", {
                    class: "header-text",
                    "data-external": `pricing-table-header-text-name:${column.name}`
                }, _toDisplayString(_ctx.getColumnDisplayName(column.id, _ctx.columns)), 9, _hoisted_1)
            ], 2));
        }), 128))
    ], 4));
}
